import BaseApi from '@/api/Base/BaseApi'
import { GetOcrCharacterSetResponse, UpdateOcrCharacterSetPayload } from '@/api/Ocr/types'

const ROOT = '/ocr'

export default class OcrApi extends BaseApi {
  getOcrCharacterSet(projectId: string) {
    return this.agent.get<GetOcrCharacterSetResponse>(`${ROOT}/${projectId}`)
  }

  updateOcrCharacterSet(payload: UpdateOcrCharacterSetPayload) {
    const { projectId, ...rest } = payload
    return this.agent.put(`${ROOT}/${projectId}`, rest)
  }
}
